import proj4 from 'proj4'
import proj from 'ol/proj'
import tileGrid from 'ol/tilegrid'
import "./Tile";

proj.setProj4(proj4)
/** @namespace GIS.Map.Layer.OL3 */
NS("GIS.Map.Layer.OL3");

// currently ol3 expects that proj4 available globally https://github.com/openlayers/ol3/issues/3990
proj4.defs("EPSG:3395", "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs");

/**
 * @class
 * @extends GIS.Map.Layer.OL3.Tile
 */
GIS.Map.Layer.OL3.Yandex = Class(GIS.Map.Layer.OL3.Tile, /** @lends GIS.Map.Layer.OL3.Yandex.prototype */ {
    title: 'Yandex Tiles',
    attributions: ["Картографические данные © Яндекс, 2015"],
    maxZoom: 18,
    layerName: 'sat',
    projection: (() => {
        const projection = proj.get('EPSG:3395');
        projection.setExtent(proj.get('EPSG:3857').getExtent());

        return projection.getCode();
    })(),
    url: 'http://{layerName}0{0-4}.maps.yandex.net/tiles?l={layerName}&v=4.47.1&x={x}&y={y}&z={z}&lang=ru_RU',
    /** @inheritDoc */
    initialize()
    {
        this.ParentCall();
        this.name = "GIS.Map.Layer.OL3.Yandex:" + uuid.v4();
    },
    /** @inheritDoc */
    createSource: function(options = {})
    {
        options.tileGrid = tileGrid.createXYZ({
            extent: this.map.getProjection().getExtent(),
            maxZoom: Util.coalesce(options.maxZoom, this.map.maxZoom),
            minZoom: Util.coalesce(options.minZoom, this.map.minZoom),
            tileSize: Util.coalesce(options.tileSize, [256, 256])
        });

        return this.Parent(options);
    }
});
